import React from "react";
import footerlogo from "../../../images/footer-logo-michugol.png";

function Footer(props) {
  return (
    <footer className="footer">
      <div className="footerInner">
        <ul className="guide">
          <li className="pd10">
            <a href="https://www.incheon.go.kr/IC050201" target="_blank">
              누리집 이용안내
            </a>
          </li>
          <li className="pd10">
            <a href="https://www.incheon.go.kr/IC050401" target="_blank">
              <strong style={{ color: "#f7b02a" }}>개인정보처리방침</strong>
            </a>
          </li>
          <li className="pd10">
            <a href="https://www.incheon.go.kr/IC050601" target="_blank">
              저작권정책
            </a>
          </li>
          <li className="pd10">
            <a href="https://www.incheon.go.kr/IC050701" target="_blank">
              이메일무단수집거부
            </a>
          </li>
          <li className="pd10">
            <a href="https://www.incheon.go.kr/IC050101" target="_blank">
              누리집 안내지도
            </a>
          </li>
        </ul>
      </div>
      <div className="locate">
        <address className="address">
          <p className="address">
            <span>21554 인천광역시 남동구 정각로 29(구월동) TEL:(032)120</span>
          </p>
          <p className="capyright">
            © Incheon Metropolitan City. All rights reserved.
          </p>
        </address>
        <a
          href="https://www.incheon.go.kr/IC030601"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={footerlogo} alt="미추홀 콜센터" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
